"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBookmarkByName = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
function findBookmarkByName(documentModel, check) {
    var bkms = [];
    number_1.NumberMapUtils.forEach(documentModel.subDocuments, function (sd) {
        list_1.ListUtils.forEach(sd.bookmarks, function (bkm) {
            if (check(bkm))
                bkms.push(bkm);
        });
    });
    return bkms;
}
exports.findBookmarkByName = findBookmarkByName;
